import type {
  NextOutboundCallRequest,
  OutboundCallResponse,
  TestCallOptions,
  TestCallRequest,
  TestCallResponse,
} from '@api-contracts/api';

export abstract class VoiceRepository {
  public abstract createTestCall(
    request: TestCallRequest,
  ): Promise<TestCallResponse>;

  public abstract getTestCallOptions(): Promise<TestCallOptions>;

  public abstract launchNextOutboundCall(
    request: NextOutboundCallRequest,
  ): Promise<OutboundCallResponse>;
}
